import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Route, Routes } from "react-router-dom";
import DivisionListPage from "./list/Page";
import DivisionEditPage from './edit/Page';
const Dispatch = () => {
    return (_jsxs(Routes, { children: [_jsx(Route, { path: "edit/:divisionId", element: _jsx(DivisionEditPage, {}) }), _jsx(Route, { path: "list", element: _jsx(DivisionListPage, {}) })] }));
};
export default Dispatch;
